import { create } from 'zustand'

import { ABIDescription, CompiledContract } from '@remixproject/plugin-api';

export type ContractData = {
    filePath: string,
    name: string,
    address: string,
    abi: ABIDescription[],
    bytecode: string,
    deployedBytecode: string
}

type State = {
    compiledContracts: ContractData[]
    currentCompiledContractFilePath: string
    currentCompiledContractName: string
    currentCompiledContractAbi: ABIDescription[]
    currentCompiledContractBytecode: string
}

type Action = {
    updateCompiledContracts: (newCompiledContracts: { [filePath: string]: { [name: string]: CompiledContract } }) => void,
    updateCurrentCompiledContract: (contract: ContractData) => void,
    reset: () => void
}

const initialState: State = {
    compiledContracts: [],
    currentCompiledContractFilePath: '',
    currentCompiledContractName: '',
    currentCompiledContractAbi: [],
    currentCompiledContractBytecode: ''
}

export const useCompiledContractStore = create<State & Action>()((set) => ({
    ...initialState,
    updateCompiledContracts: (newCompiledContracts) => {
        const newContracts: Array<ContractData> = []

        for (const [filePath, value] of Object.entries(newCompiledContracts)) {
            for (const [contractName, contract] of Object.entries(value)) {
                newContracts.push({
                    filePath: filePath,
                    name: contractName,
                    address: '',
                    abi: contract.abi,
                    bytecode: contract.evm.bytecode.object,
                    deployedBytecode: contract.evm.deployedBytecode.object
                })
            }
        }

        set(({
            compiledContracts: newContracts,
            currentCompiledContractFilePath: newContracts[0].filePath,
            currentCompiledContractName: newContracts[0].name,
            currentCompiledContractAbi: newContracts[0].abi,
            currentCompiledContractBytecode: newContracts[0].bytecode
        }))
    },
    updateCurrentCompiledContract: (contract) => {
        set({
            currentCompiledContractFilePath: contract.filePath,
            currentCompiledContractName: contract.name,
            currentCompiledContractAbi: contract.abi,
            currentCompiledContractBytecode: contract.bytecode,
        })
    },
    reset: () => { set(initialState) } 
}))